import type { IOrganization } from '../../../../interfaces/organization';
import type { IPractitioner } from '../../../../interfaces/practitioner';
import type { IRequestGetOne } from '../../../../interfaces/requestGetOne';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { translateKey } from '../../../../../translate';
import { FormDivider } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProfileImageWithName } from '../../../episodes/common';

export function ProfileImages(props: {
    alternativeLabelText?: string;
    organization?: IOrganization | null;
    practitioner?: IPractitioner | null;
    request: IRequestGetOne;
    showAlsoWhenNotRequested?: boolean;
    showFormDivider?: boolean;
}) {
    if (props.request.status !== RequestStatus.requested && !props.showAlsoWhenNotRequested) {
        return null;
    }

    if (props.request.recipientPractitioner || props.request.recipientOrganization) {
        return (
            <>
                <HorizontalFormGroupRead>
                    <FormLabel>
                        {props.alternativeLabelText
                            ? translateKey(props.alternativeLabelText)
                            : translateKey('request.sentTo')}
                    </FormLabel>
                    <InputContainer>
                        <ProfileImageWithName
                            organization={props.organization ? props.organization : props.request.recipientOrganization}
                            practitioner={props.practitioner ? props.practitioner : props.request.recipientPractitioner}
                        />
                    </InputContainer>
                </HorizontalFormGroupRead>

                {props.showFormDivider && <FormDivider />}
            </>
        );
    }

    return null;
}
